import { render, staticRenderFns } from "./RejectedList.vue?vue&type=template&id=a33c5a58&"
import script from "./RejectedList.vue?vue&type=script&lang=js&"
export * from "./RejectedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports